export const STATUS_META = {
  pending: { label: 'Pending', accent: '#f59e0b', bg: 'bg-amber-500/10', text: 'text-amber-400', border: 'border-amber-500/30' },
  in_progress: { label: 'In Progress', accent: '#3b82f6', bg: 'bg-blue-500/10', text: 'text-blue-400', border: 'border-blue-500/30' },
  completed: { label: 'Completed', accent: '#10b981', bg: 'bg-emerald-500/10', text: 'text-emerald-400', border: 'border-emerald-500/30' },
  on_hold: { label: 'On Hold', accent: '#a855f7', bg: 'bg-purple-500/10', text: 'text-purple-400', border: 'border-purple-500/30' },
  cancelled: { label: 'Cancelled', accent: '#6b7280', bg: 'bg-gray-500/10', text: 'text-gray-400', border: 'border-gray-500/30' },
};

export const STATUS_ORDER = ['pending', 'in_progress', 'on_hold', 'completed', 'cancelled'];

export const SUBTASK_STATUS_META = {
  pending: STATUS_META.pending,
  in_progress: STATUS_META.in_progress,
  done: { ...STATUS_META.completed, label: 'Done' },
  cancelled: STATUS_META.cancelled,
};

export const SUBTASK_STATUS_ORDER = ['pending', 'in_progress', 'done', 'cancelled'];

export const normSub = (s) => {
  const status = SUBTASK_STATUS_META[s.status] ? s.status : (s.done ? 'done' : 'pending');
  return { ...s, status, progress: status === 'done' ? 100 : Number(s.progress) || 0 };
};

export const subtaskStats = (subs = []) => {
  const all = subs.map(normSub);
  const active = all.filter((s) => s.status !== 'cancelled');
  return {
    done: active.filter((s) => s.status === 'done').length,
    active: active.length,
    cancelled: all.length - active.length,
    avg: active.length ? Math.round(active.reduce((sum, s) => sum + s.progress, 0) / active.length) : null,
  };
};

export const PRIORITY_META = {
  low: { label: 'Low', text: 'text-gray-400' },
  medium: { label: 'Medium', text: 'text-blue-400' },
  high: { label: 'High', text: 'text-amber-400' },
  very_high: { label: 'Very High', text: 'text-red-400' },
};

export const IMPACT_META = PRIORITY_META;

export const isoWeekOf = (dateObj) => {
  const d = new Date(Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  return `${d.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`;
};

export const shiftWeek = (week, delta) => {
  const [y, w] = week.split('-W');
  const monday = new Date(Date.UTC(Number(y), 0, 4));
  const dayNum = monday.getUTCDay() || 7;
  monday.setUTCDate(monday.getUTCDate() - dayNum + 1 + (Number(w) - 1 + delta) * 7);
  return isoWeekOf(new Date(monday.getUTCFullYear(), monday.getUTCMonth(), monday.getUTCDate()));
};
